module.exports = __webpack_public_path__ + "media/images/landing_page/failiem_upload_mobile (copy)-a54c36af8fc5234e273d7da39e8151b9.png";